import throttle from 'lodash/throttle';

export default {

  init() {

    // defaults
    this.lastScroll = 0;
    this.scrollY = window.pageYOffset;
    this.envWidth = window.innerWidth;
    this.envHeight = window.innerHeight;
    this.scrollDir = 'down';

    this.onResize = this.onResize.bind( this );
    this.onScroll = this.onScroll.bind( this );
    this.updateScrollDir = this.updateScrollDir.bind( this );

    window.addEventListener( 'scroll', throttle( this.onScroll ) );
    window.addEventListener( 'resize', throttle( this.onResize ) );

    this.onReady = this.onReady.bind(this);
    $( document ).ready( this.onReady );

  },

  isOnScreen( el ) {
    const win = $( window );
    const winHeight = win.height();
    const viewport = {
      top : win.scrollTop(),
      left : win.scrollLeft(),
    };

    //viewport.right = viewport.left + win.width();
    // viewport.top = viewport.top;
    viewport.bottom = (viewport.top + 200) + winHeight;

    const bounds = el.offset();
    //bounds.right = bounds.left + this.outerWidth();
    // bounds.top = bounds.top - 150;
    bounds.bottom = (bounds.top + winHeight) + el.outerHeight();

    return (!(viewport.bottom < bounds.top || viewport.top > bounds.bottom));
  },

  onReady() {

    this.setUserAgents();

  },

  onResize() {

    this.envWidth = window.innerWidth;
    this.envHeight = window.innerHeight;

  },

  onScroll() {

    this.scrollY = window.pageYOffset;

    this.updateScrollDir();

  },

  updateScrollDir() {

    if ( this.scrollY > this.lastScroll ) {
      this.scrollDir = 'down';
    } else {
      this.scrollDir = 'up';
    }

    this.lastScroll = this.scrollY;

  },

  setUserAgents() {

    const agent = window.navigator.userAgent.toLowerCase();
    var elClass = '';

    if ( agent.indexOf( 'windows' ) > 0 && agent.indexOf( 'trident' ) > 0 ) {
      elClass += 'ie ';
    } else {
      elClass += 'no-ie ';
    }

    if ( agent.indexOf( 'mobile' ) > 0 ) {
      elClass += 'mobile ';
    } else {
      elClass += 'no-mobile ';
    }

    if ( agent.indexOf( 'ipad' ) > 0 ) {
      elClass += 'tablet ';
    } else {
      elClass += 'no-tablet ';
    }

    if ( agent.indexOf( 'safari' ) > 0 && agent.indexOf( 'chrome' ) <= 0 ) {
      elClass += 'safari ';
    } else {
      elClass += 'no-safari ';
    }

    if ( agent.indexOf( 'firefox' ) > 0 ) {
      elClass += 'firefox ';
    } else {
      elClass += 'no-firefox ';
    }

    if ( agent.indexOf( 'edge' ) > 0 ) {
      elClass += 'edge ';
    } else {
      elClass += 'no-edge ';
    }

    if ( agent.indexOf( 'ipad' ) > 0 || agent.indexOf( 'mobile' ) > 0 ) {
      elClass += 'touch';
    } else
    {
      elClass += 'no-touch';
    }

    $( 'html' ).addClass( elClass );

  },
}



// WEBPACK FOOTER //
// ./scripts/modules/utils.js